export const messages = {
  option: { id: 'admin/promotions.form.utils.multi-input.add' },
  validation: {
    duplicated: {
      id: 'admin/promotions.form.utils.multi-input.duplicated',
    },
    maxEntries: {
      id: 'admin/promotions.form.utils.maximum-amount-of-items',
    },
  },
  counter: { id: 'admin/promotions.form.utils.count' },
}
